// extracted by mini-css-extract-plugin
export var productImage = "_pu-1";
export var viewLink = "_pu-2";
export var wishlistItem = "_pu-0";